import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';

import { ActionInterface } from 'common/action.interface';
import {
 PrintModelTypes,
 PrintModelInterface,
} from './types';

// List PrintModel
export const listPrintModelsRequest = (payload: object) =>
  action(PrintModelTypes.LIST_PRINT_MODELS_REQUEST, payload);
export const listPrintModelsSuccess = (payload: {
  printModelsList: PrintModelInterface[];
  totalCount?: number;
}) => action(PrintModelTypes.LIST_PRINT_MODELS_SUCCESS, payload);
export const listPrintModelsFailure = () =>
  action(PrintModelTypes.LIST_PRINT_MODELS_FAILURE);

// Create PrintModel
export const createPrintModelRequest = (payload: object) =>
  action(PrintModelTypes.CREATE_PRINT_MODEL_REQUEST, payload);
export const createPrintModelSuccess = (payload: {
  printModelData: PrintModelInterface;
}) => action(PrintModelTypes.CREATE_PRINT_MODEL_SUCCESS, payload);
export const createPrintModelFailure = () =>
  action(PrintModelTypes.CREATE_PRINT_MODEL_FAILURE);

// Update PrintModel
export const updatePrintModelRequest = (payload: object) =>
  action(PrintModelTypes.UPDATE_PRINT_MODEL_REQUEST, payload);
export const updatePrintModelSuccess = (payload: {
  printModelData: PrintModelInterface;
}) => action(PrintModelTypes.UPDATE_PRINT_MODEL_SUCCESS, payload);
export const updatePrintModelFailure = () =>
  action(PrintModelTypes.UPDATE_PRINT_MODEL_FAILURE);

// Delete PrintModel
export const deletePrintModelRequest = (payload: object) =>
  action(PrintModelTypes.DELETE_PRINT_MODEL_REQUEST, payload);
export const deletePrintModelSuccess = () => 
  action(PrintModelTypes.DELETE_PRINT_MODEL_SUCCESS);
export const deletePrintModelFailure = () =>
  action(PrintModelTypes.DELETE_PRINT_MODEL_FAILURE);